// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.header.full-size .logotype img,.header.full-size .logotype svg,.header.headroom--not-top .logotype img,.header.headroom--not-top .logotype svg{color:var(--logotype-pinned-color)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
